<ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
    <span class="chevron left"></span>
    <span class="chevron right"></span>
</ngx-spinner>

<div class="main-view">
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <div class="m-content">
      <div class="m-portlet" style="background: black;" *ngIf="form">
        <div class="editor" [formGroup]="form" style="flex-direction: row; justify-content: space-between;">
          <div style="width: 100%;" #main>
            <div style="display: flex; flex-direction: column; justify-content: space-between;">
                
              <div *ngIf="showFullScreenPreview" #preview class="public-preview">
                <app-fullscreen-preview
                  [state]="state"
                  [colorToDisplay]="colorToDisplay"
                  [colorSegmentOpacity]="colorSegmentOpacity"
                  [imageSegmentOpacity]="imageSegmentOpacity"
                  [selectedColorSegment]="selectedColorSegment"
                  [selectedImageSegment]="selectedImageSegment"
                  [playPosition]="player.playPosition"
                  [isPlaying]="player.isPlaying"
                  [mp3Url]="trackUrl"
                  [duration]="trackDuration"
                  (changePlayPosition)="player.seekPosition($event / 1000)"
                  (play)="player.play()"
                  (pause)="player.pause()"
                >
                </app-fullscreen-preview>
              </div>
            </div>

            <app-mp3-player
              [hidden]="true"
              [disableHoverTips]="true"
              tooltip="Timeline where your images, colors, sound effects, and torches will appear. Drag the Playback Scrubber (the red line) along the Timeline to start playback from any point in the song. Drag the segments to move them or edit them below. Segments of the same kind cannot overlap"
              #player
              style="grid-column: 1/4"
              canCropEnd="false"
              [cropEndPercent]="0"
              [url]="trackUrl"
              [segmentsFormArray]="this.form.get('customModeData.segments')"
              [selectedSegmentIndex]="
                form.get('customModeData.selectedSegmentIndex').value || 0
              "
              [currentSoundEffect]="currentSoundEffect"
              [editorMode]="editorMode"
              [segmentMode]="segmentMode"
              [torchArray]="trackOperations"
              [main]="main"
              (playPositionChanged)="player.playPosition = $event"
              [useForLightshowEditor]="false"
              [venueId]="venueId"
            >
            </app-mp3-player>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>